module.exports = __webpack_public_path__ + "static/media/tag.af5d60c8.svg";